import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=996aeb92&scoped=true"
import script from "./jobDetails.vue?vue&type=script&lang=js"
export * from "./jobDetails.vue?vue&type=script&lang=js"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=996aeb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996aeb92",
  null
  
)

export default component.exports